export default "__VITE_ASSET__DFEAf75Z__"